import Header from "./../compoents/common/Header";
import Footer from "./../compoents/common/Footer";
import { useEffect, useState } from "react";
import { pageDataApi, homePageApi, baseUrl } from "../utils/apis";
import ReactMarkdown from "react-markdown";

const AboutPage = (props) => {
  const [homePageState, setHomePageState] = useState({});
  const [pageData, setPageData] = useState({});

  useEffect(() => {
    homePageApi().then((data) => {
      console.log(data);
      if (data) {
        setHomePageState(data);
      }
    });
    pageDataApi("about").then((data) => {
      console.log(data);
      if (data && data.length > 0) {
        setPageData(data[0]);
      }
    });
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props]);

  return (
    <>
      <Header
        emailText={homePageState.contactUs}
        phoneText={homePageState.PhoneNumber}
      />
      <div
        class="full_width ds_page_banner bg-center"
        style={{
          background:
            pageData && pageData.banner
              ? "url(" + baseUrl + pageData.banner.url + ")"
              : "black",
        }}
      >
        <div class="black_overlay">
          <div class="container">
            <div class="row">
              <div class="page_content_wrap">
                <div class="page_heading">
                  <h1>{"Privacy Policy"}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="courses" className="full_width contact_section">
        <div className="container">
          <div className="row">
            {/* heading section */}
            <div className="content">
              <div>
                <p>PRIVACY STATEMENT</p>
                <p>
                  <br />
                </p>
                <p>----</p>
                <p>
                  <br />
                </p>
                <p>SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?</p>
                <p>
                  <br />
                </p>
                <p>
                  When you purchase something from our store, as part of the
                  buying and selling process, we collect the personal
                  information you give us such as your name, address and email
                  address.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  When you browse our store, we also automatically receive your
                  computer’s internet protocol (IP) address in order to provide
                  us with information that helps us learn about your browser and
                  operating system.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  Email marketing (if applicable): With your permission, we may
                  send you emails about our store, new products and other
                  updates.
                </p>
                <p>
                  <br />
                </p>
                <p>SECTION 2 - CONSENT</p>
                <p>
                  <br />
                </p>
                <p>How do you get my consent?</p>
                <p>
                  <br />
                </p>
                <p>
                  When you provide us with personal information to complete a
                  transaction, verify your credit card, place an order, arrange
                  for a delivery or return a purchase, we imply that you consent
                  to our collecting it and using it for that specific reason
                  only.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  If we ask for your personal information for a secondary
                  reason, like marketing, we will either ask you directly for
                  your expressed consent, or provide you with an opportunity to
                  say no.
                </p>
                <p>
                  <br />
                </p>
                <p>How do I withdraw my consent?</p>
                <p>
                  <br />
                </p>
                <p>
                  If after you opt-in, you change your mind, you may withdraw
                  your consent for us to contact you, for the continued
                  collection, use or disclosure of your information, at anytime,
                  by contacting us at{" "}
                  <strong>Saidrivingacademy@gmail.com&nbsp;</strong>or mailing
                  us &nbsp;at: <strong>Sai</strong>
                  <strong>&nbsp;D</strong>
                  <strong>riving</strong>
                  <strong>&nbsp;A</strong>
                  <strong>
                    cademy 605 pride empire near union bank racecourse ring
                    rajkot
                  </strong>
                </p>
                <p>SECTION 3 - DISCLOSURE</p>
                <p>
                  <br />
                </p>
                <p>
                  We may disclose your personal information if we are required
                  by law to do so or if you violate our Terms of Service.
                </p>
                <p>
                  <br />
                </p>
                <p>SECTION 4 - PAYMENT</p>
                <p>
                  <br />
                </p>
                <p>
                  We use Razorpay for processing payments. We/Razorpay do not
                  store your card data on their servers. The data is encrypted
                  through the Payment Card Industry Data Security Standard
                  (PCI-DSS) when processing payment. Your purchase transaction
                  data is only used as long as is necessary to complete your
                  purchase transaction. After that is complete, your purchase
                  transaction information is not saved.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  Our payment gateway adheres to the standards set by PCI-DSS as
                  managed by the PCI Security Standards Council, which is a
                  joint effort of brands like Visa, MasterCard, American Express
                  and Discover.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  PCI-DSS requirements help ensure the secure handling of credit
                  card information by our store and its service providers.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  For more insight, you may also want to read terms and
                  conditions of razorpay on{" "}
                  <a href="https://razorpay.com/">
                    <u>https://razorpay.com</u>
                  </a>
                </p>
                <p>
                  <br />
                </p>
                <p>SECTION 5 - THIRD-PARTY SERVICES</p>
                <p>
                  <br />
                </p>
                <p>
                  In general, the third-party providers used by us will only
                  collect, use and disclose your information to the extent
                  necessary to allow them to perform the services they provide
                  to us.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  However, certain third-party service providers, such as
                  payment gateways and other payment transaction processors,
                  have their own privacy policies in respect to the information
                  we are required to provide to them for your purchase-related
                  transactions.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  For these providers, we recommend that you read their privacy
                  policies so you can understand the manner in which your
                  personal information will be handled by these providers.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  In particular, remember that certain providers may be located
                  in or have facilities that are located a different
                  jurisdiction than either you or us. So if you elect to proceed
                  with a transaction that involves the services of a third-party
                  service provider, then your information may become subject to
                  the laws of the jurisdiction(s) in which that service provider
                  or its facilities are located.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  Once you leave our store’s website or are redirected to a
                  third-party website or application, you are no longer governed
                  by this Privacy Policy or our website’s Terms of Service.
                </p>
                <p>
                  <br />
                </p>
                <p>Links</p>
                <p>
                  <br />
                </p>
                <p>
                  When you click on links on our store, they may direct you away
                  from our site. We are not responsible for the privacy
                  practices of other sites and encourage you to read their
                  privacy statements.
                </p>
                <p>
                  <br />
                </p>
                <p>SECTION 6 - SECURITY</p>
                <p>
                  <br />
                </p>
                <p>
                  To protect your personal information, we take reasonable
                  precautions and follow industry best practices to make sure it
                  is not inappropriately lost, misused, accessed, disclosed,
                  altered or destroyed.
                </p>
                <p>SECTION 7 - COOKIES</p>
                <p>
                  <br />
                </p>
                <p>
                  We use cookies to maintain session of your user. It is not
                  used to personally identify you on other websites.
                </p>
                <p>
                  <br />
                </p>
                <p>SECTION 8 - AGE OF CONSENT</p>
                <p>
                  <br />
                </p>
                <p>
                  By using this site, you represent that you are at least the
                  age of majority in your state or province of residence, or
                  that you are the age of majority in your state or province of
                  residence and you have given us your consent to allow any of
                  your minor dependents to use this site.
                </p>
                <p>
                  <br />
                </p>
                <p>SECTION 9 - CHANGES TO THIS PRIVACY POLICY</p>
                <p>
                  <br />
                </p>
                <p>
                  We reserve the right to modify this privacy policy at any
                  time, so please review it frequently. Changes and
                  clarifications will take effect immediately upon their posting
                  on the website. If we make material changes to this policy, we
                  will notify you here that it has been updated, so that you are
                  aware of what information we collect, how we use it, and under
                  what circumstances, if any, we use and/or disclose it.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  If our store is acquired or merged with another company, your
                  information may be transferred to the new owners so that we
                  may continue to sell products to you.
                </p>
                <p>
                  <br />
                </p>
                <p>QUESTIONS AND CONTACT INFORMATION</p>
                <p>
                  <br />
                </p>
                <p>
                  If you would like to: access, correct, amend or delete any
                  personal information we have about you, register a complaint,
                  or simply want more information contact our Privacy Compliance
                  Officer at <strong>Saidrivingacademy@gmail.com&nbsp;</strong>
                  or by mail at <strong>Sai</strong>
                  <strong>&nbsp;D</strong>
                  <strong>riving</strong>
                  <strong>&nbsp;A</strong>
                  <strong>cademy&nbsp;</strong>
                  <strong>&nbsp;</strong>
                  <strong>
                    605 pride empire near union bank racecourse ring rajkot
                  </strong>
                </p>
                <p>
                  <br />
                </p>
                <p>[Re: Privacy Compliance Officer]</p>
                <p>
                  <br />
                </p>
                <p>
                  [622 Manglam Electronic Market Jaipur Rajasthan India 302001]
                </p>
                <p>
                  <br />
                </p>
                <p>----</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer
        aboutText={homePageState.About}
        addressText={homePageState.Address}
        emailText={homePageState.contactUs}
        phoneText={homePageState.PhoneNumber}
      />
    </>
  );
};

export default AboutPage;
